import { createApp } from 'vue';
import App from './components/App.js';
import 'es6-promise/auto';

// Import Plugins
import AlertPlugin from './plugins/AlertPlugin';
import CopyToClipboardPlugin from './plugins/CopyToClipboardPlugin';
import Snotify from 'vue3-snotify';
import 'eonasdan-bootstrap-datetimepicker';
import imageCropUpload from 'vue-image-crop-upload';
import vSelect from 'vue-select';
import moment from 'moment';
import store from "./stores";

require('./bootstrap');
require('./waves');

const _ = require('lodash');
window.moment = moment;

// Create Vue app
const app = createApp(App);

// Create Vuex Store
app.use(store);

// Moment.js duration format
let momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);

// Vue global translation function
window.trans = app.config.globalProperties.trans = (string, replacements = {}) => {
    let translation = window.translations ? _.get(window.translations, string, string) : string;

    // Replace all placeholders with actual values
    Object.keys(replacements).forEach(key => {
        translation = translation.replace(`:${key}`, replacements[key]);
    });

    return translation;
};

if (window.locale && window.locale !== 'en') {
    require('moment/locale/nl.js');
    window.moment().locale(window.locale);
}

if (window.locale && window.locale != 'en') {
    // import moment js locale file
    require('moment/locale/nl.js');

    // set locale globally
    window.moment().locale(window.locale);
    //get dynamic language file
    flatpickr.localize(getLocale(window.locale));
}
//function to get language files dynamically
function getLocale(locale) {
    const l = require(`flatpickr/dist/l10n/${locale}.js`);
    return l.default[locale];
}

// Require fitty
window.fitty = require('fitty').default;

// Get OS
window.getOS = function () {
    const platform = window.navigator.platform;
    if (['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)) return 'Mac OS';
    if (['iPhone', 'iPad', 'iPod'].includes(platform)) return 'iOS';
    if (['Win32', 'Win64', 'Windows', 'WinCE'].includes(platform)) return 'Windows';
    if (/Android/.test(window.navigator.userAgent)) return 'Android';
    if (/Linux/.test(platform)) return 'Linux';
    return null;
};

// Import required JS libraries
require('../../node_modules/select2/dist/js/select2.full.min.js');
require('../../node_modules/toastr/build/toastr.min.js');
require('../../node_modules/loaders.css/loaders.css.js');
require('../../node_modules/jquery-bar-rating/dist/jquery.barrating.min.js');
require('../../node_modules/inputmask/dist/jquery.inputmask.bundle');
require('../../node_modules/intl-tel-input/build/js/intlTelInput.min.js');
require('./plugins/jquery.stickyheader.js');

// Register Plugins
if (process.env.NODE_ENV === 'production') {
    const { flare } = require('@flareapp/flare-client');
    const { flareVue } = require('@flareapp/flare-vue');

    flare.light('cbpzJfufcJGMhzNfOejxbzCVdh7RIGpK');

    // Don't report axios request cancellations (e.g. navigating the planning
    // calendar cancels in-flight requests on purpose) — these surface as
    // "canceled" unhandled rejections but are expected behaviour.
    flare.beforeEvaluate = (error) => {
        if (window.axios && window.axios.isCancel(error)) {
            return false;
        }
        return error;
    };

    app.use(flareVue);
}

app.use(AlertPlugin);
app.use(CopyToClipboardPlugin);
app.use(Snotify, {
    toast: {
        position: 'rightBottom',
        backdrop: -1,
        maxOnScreen: 1,
        timeout: 1500,
    },
});

import FloatingVue from 'floating-vue'
app.use(FloatingVue)
import 'floating-vue/dist/style.css'
import VueFlatpickr from "vue-flatpickr-component";

// Vue Directives
app.directive('focus', {
    mounted(el) {
        el.focus();
    },
});

// Vue Filters (Moved to `app.config.globalProperties.$filters`)
app.config.globalProperties.$filters = {
    date(value) {
        return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
};

// Register Vue Components
app.component('notification-component', require('./components/helpers/NotificationComponent.vue').default);
app.component('timepicker', require('./components/helpers/TimePickerComponent.vue').default);
app.component('select2', require('./components/helpers/Select2Component.vue').default);
app.component('star-rating', require('./components/helpers/StarRatingComponent.vue').default);
app.component('modal', require('./components/helpers/ModalComponent.vue').default);
app.component('button-delete-component', require('./components/helpers/ButtonDeleteComponent.vue').default);
app.component('image-crop-upload-component', imageCropUpload);
app.component('input-mask', require('./components/helpers/InputMaskComponent.vue').default);
app.component('input-time', require('./components/helpers/InputTimeComponent.vue').default);
app.component('phone-mask', require('./components/helpers/PhoneMaskComponent.vue').default);
app.component('pagination', require('./components/helpers/PaginationComponent.vue').default);
app.component('autocomplete', require('./components/helpers/AutocompleteComponent.vue').default);
app.component('autocomplete-dynamic-values', require('./components/helpers/AutocompleteDynamicValues.vue').default);
app.component('contextmenu', require('./components/helpers/ContextMenuComponent.vue').default);
app.component('color-picker', require('./components/helpers/ColorPickerComponent.vue').default);
app.component('contact-form-component', require('./components/contact/FormComponent.vue').default);
app.component('confirmation-modal-component', require('./components/helpers/ConfirmationModalComponent.vue').default);
app.component('planning-component', require('./components/planning/PlanningComponent.vue').default);
app.component('export-sap-component', require('./components/client-area/waak/ExportSapComponent.vue').default);
app.component('export-withholding-tax-component', require('./components/client-area/waak/ExportWithholdingTaxComponent.vue').default);
app.component('antoon-decock-export-rsz-aangifte-component', require('./components/client-area/antoon-decock/ExportRszAangifteComponent.vue').default);
app.component('import-wizard-component', require('./components/imports/ImportWizardComponent.vue').default);
app.component('import-progress-component', require('./components/imports/ImportProgressComponent.vue').default);

// Register vSelect globally
app.component('v-select', vSelect);

// Mixin for global `route()` method
app.mixin({
    methods: {
        route(name, params = {}) {
            return window.route(name, params);
        },
    },
});

app.mount('#vue-layout');